import { Link } from "react-router-dom";

import { BASE_URL } from "../../../Constents";
import logo from "../../../images/YAAMS_bg_Img.png";
const RejectedMailMessage = () => {
  return (
    <>
      <div className="maincontent">
        <div className="row highlight all_form_spacing">
          <div className="col-md-6  align-self-center">
            <img src={logo} alt="YAAMS logo" className=" img-fluid" />
          </div>
          <div className=" mt-5 col-md-6 align-self-center text-center">
            <div className=" ">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 130.2 130.2"
                className="approve_reject_svg"
              >
                <circle
                  class="path circle"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-miterlimit="10"
                  cx="65.1"
                  cy="65.1"
                  r="62.1"
                />
                <line
                  class="path line"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="34.4"
                  y1="37.9"
                  x2="95.8"
                  y2="92.3"
                />
                <line
                  class="path line"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="95.8"
                  y1="38"
                  x2="34.4"
                  y2="92.2"
                />
              </svg>

              <h3 className="mt-4">
                Leave request has been{" "}
                <span className="text-danger">Rejected</span>
              </h3>
              <p className="m-0">
                Mail and notification has been sent to the employee
              </p>
              <Link className="btn btn-outline-danger mt-4" to={BASE_URL}>
                Go to Home Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectedMailMessage;
